// This function will need updating to include regionalisation when the US PLPs etc. go out

export const siteUrl =
  process.env.PUBLIC_SITE_URL ?? "https://www.beautypie.com";
